import { useEffect } from 'react';
var WINDOW_COUNTER_KEY = '__x_disable_counter';
export function useDisableScroll(isOpen) {
    useEffect(function () {
        if (isOpen) {
            var _window_1 = window;
            _window_1[WINDOW_COUNTER_KEY] = _window_1[WINDOW_COUNTER_KEY] || 0;
            _window_1[WINDOW_COUNTER_KEY] += 1;
            document.documentElement.classList.add('overflow-hidden');
            return function () {
                _window_1[WINDOW_COUNTER_KEY] -= 1;
                if (_window_1[WINDOW_COUNTER_KEY] === 0) {
                    document.documentElement.classList.remove('overflow-hidden');
                }
            };
        }
    }, [isOpen]);
}
